export default __webpack_public_path__ + "static/media/abbeville10.5138e897.jpg";